export function getCookiebotId() {
  const hostname = window.location.hostname.toLowerCase();
    let cookiebotId;

  if (hostname.includes("mywep")) {
    cookiebotId =  process.env.REACT_APP_COOKIEBOT_ID_MYWEP;
  }
  else if (hostname.includes('mycls')) {
    cookiebotId = process.env.REACT_APP_COOKIEBOT_ID_MYCLS;
  } 
  else if (hostname.includes('myeduonline')) {
    cookiebotId = process.env.REACT_APP_COOKIEBOT_ID_MYEDU;
  } 
  else if (hostname.includes('mycamps')) {
    cookiebotId = process.env.REACT_APP_COOKIEBOT_ID_MYCAMPS;
  }
  
  return cookiebotId;
}